//
// MuxManager.js
// transport
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../lib";
import "./Voucher";

var MuxManager = createModule("transport::MuxManager", [], EventDispatcher, [
    ,
    ,
    ,
    ,
    {
        removeFavorites: [1,[1]],
        addFavorites: [1,[1]],
    },
    ,
    ,
]);
export default MuxManager;
